import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { InvitationPage } from "./invitation.page";

const routes: Routes = [
  {
    path: "",
    component: InvitationPage,
  },
  {
    path: "add-invitation",
    loadChildren: () =>
      import("./add-invitation/add-invitation.module").then(
        (m) => m.AddInvitationPageModule
      ),
      data: {
        breadcrumb: 'ADD_INVITATION.ADD_NEW_INVITATION'
      },
  },
  {
    path: "edit-invitation/:InvitationId",
    loadChildren: () =>
      import("./edit-invitation/edit-invitation.module").then(
        (m) => m.EditInvitationPageModule
      ),
      data: {
        breadcrumb: 'ADD_INVITATION.INVITATION'
      },
  },
  {
    path: "invitation-accept",
    loadChildren: () =>
      import("./../../public/invitation-accept/invitation-accept.module").then(
        (m) => m.InvitationAcceptPageModule
      )
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InvitationPageRoutingModule {}
